import { render, staticRenderFns } from "./PmauWorkshop.vue?vue&type=template&id=2d31d5d9&"
import script from "./PmauWorkshop.vue?vue&type=script&lang=js&"
export * from "./PmauWorkshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports